



















import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import basicPage from "@/layouts/basicPage.vue";
import allTrain from "@/views/train/allTrain.vue";
import myTrain from "@/views/train/myTrain.vue";
import searchInput from "@/components/searchInput.vue";
import PrimaryPage from "@/layouts/primaryPage.vue";

@Component({
    components: {PrimaryPage, basicPage, allTrain, myTrain, searchInput}
})
export default class trainIndex extends basicPage {
    customActiveKey = '0'
    hasHeight: boolean = false;

    defRoutes = [{
        path: 'train',
        breadcrumbName: '培训报名',
    }]

    handleTabClick(e) {
        this.customActiveKey = e;
    }

    mounted() {
    }

    searchData(e) {
        let targetCtrl: any;
        if (this.customActiveKey == '0') {
            targetCtrl = this.$refs['allTrainCtrl'];
        } else {
            targetCtrl = this.$refs['myTrainCtrl'];
        }
        if (targetCtrl.setKeywordsAndLoad) {
            targetCtrl.setKeywordsAndLoad(e);
        }
    }

}
